import { render, staticRenderFns } from "./AsideBarCreateTask.vue?vue&type=template&id=408a8b1d&scoped=true"
import script from "./AsideBarCreateTask.vue?vue&type=script&lang=js"
export * from "./AsideBarCreateTask.vue?vue&type=script&lang=js"
import style0 from "./AsideBarCreateTask.vue?vue&type=style&index=0&id=408a8b1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a8b1d",
  null
  
)

export default component.exports